import './styles.scss';
import ColumnWrapper from 'Layout/ColumWraper';
import FAQSideText from './FAQSideText';
import FAQItems from './FAQItems/index';
import { useSelector } from 'react-redux';
import { selectLocationsPageList } from 'store/slices/LocationsSlice';
import { useRef } from 'react';
import { useAnimation } from 'hooks/useAnimation';

const FAQ = ({ isLoading }) => {
    const container = useRef();
    const locationList = useSelector(selectLocationsPageList)
    // const isLoading = useSelector(selectCurrentLocationIsLoading)

    useAnimation({
        items: ['.faq-sidetext', '.faq-item'],
        container,
        dependencies: [isLoading],
    })


    return (
        <section ref={container} id="location-list" className="faq">
            <ColumnWrapper SideText={<FAQSideText title={locationList.Title} tag={locationList.Tag} />} >
                <FAQItems continents={locationList.continents?.data} />
            </ColumnWrapper>
        </section>
    );
};

export default FAQ;
